import { useTranslation } from 'react-i18next';
import { Button } from '@nimbus-ds/components';
import { Box } from '@nimbus-ds/components';

const LanguageSelector: React.FC = () => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  return (
    <Box display="flex" gap="2">
      <Button
        appearance={i18n.language === 'es' ? 'primary' : 'neutral'}
        onClick={() => handleLanguageChange('es')}
        size="small"
      >
        ES
      </Button>
      <Button
        appearance={i18n.language === 'pt' ? 'primary' : 'neutral'}
        onClick={() => handleLanguageChange('pt')}
        size="small"
      >
        PT
      </Button>
    </Box>
  );
};

export default LanguageSelector;

